<!-- @veltra/icons generated sha256:352739cd5465d701 gen:8 source:src/svg/normal/internet.svg -->
<script setup lang="ts">
defineOptions({ name: 'Internet' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M1.1 7.9a6.9 6.9 0 1 1 13.8 0v.2a6.9 6.9 0 1 1-13.8 0zm12.787.6h-3a9.86 9.86 0 0 1-1.956 5.427A5.9 5.9 0 0 0 13.887 8.5m-3-1h3A5.9 5.9 0 0 0 8.93 2.073 9.86 9.86 0 0 1 10.887 7.5m-1.001 0a8.87 8.87 0 0 0-1.733-4.797.19.19 0 0 0-.306 0A8.87 8.87 0 0 0 6.114 7.5zm-4.773 1h-3a5.9 5.9 0 0 0 4.956 5.427A9.86 9.86 0 0 1 5.113 8.5m0-1A9.86 9.86 0 0 1 7.07 2.073 5.9 5.9 0 0 0 2.113 7.5zm4.773 1H6.114a8.87 8.87 0 0 0 1.733 4.797.19.19 0 0 0 .306 0A8.87 8.87 0 0 0 9.886 8.5"
    />
  </svg>
</template>
